import { pinia } from '@/config/pinia'
import { defineStore } from 'pinia'

export const useRequestStore = defineStore('request', {
  // State definition
  state: () => ({
    id: '', // The ID of the request, initially set to null
    isBackup: false, // The state of the request, initially set to null
  }),

  // Getter functions (if needed)
  getters: {
    getId: (state) => state.id,
    getRequest: (state) => state.isBackup,
  },

  // Mutations to modify the state
  actions: {
    setId(id: string) {
      this.id = id
    },

    setRequest(state: boolean) {
      this.isBackup = state
    },
  },
})

// Export the Pinia store
export default pinia
